// Anonymous Gregorian algorithm (Meeus/Jones/Butcher). Returns the
// date of Easter Sunday for any year from 1583 onward. Lifted from
// the spec; sanity-checked against published Easter dates:
//
//   2026 → Sunday April 5
//   2027 → Sunday March 28
//   2028 → Sunday April 16
//   2029 → Sunday April 1
//   2030 → Sunday April 21
//
// All four pieces of the year (a..k, L, m) are intermediate values
// the algorithm needs; renaming them to descriptive names would make
// the maths harder to follow against the reference.
export function computeEasterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const L = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * L) / 451);
  const month = Math.floor((h + L - 7 * m + 114) / 31); // 3=March, 4=April
  const day = ((h + L - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day); // JS months are 0-indexed
}

// Convenience for the resolver: Easter accessory active for the
// week before + week after Easter Sunday (15 days total per spec).
export function easterWindow(year) {
  const sunday = computeEasterSunday(year);
  const start = new Date(sunday); start.setDate(start.getDate() - 7);
  const end = new Date(sunday); end.setDate(end.getDate() + 7);
  return { start, end };
}
